<template>
  <div class="text-body-1"><slot></slot></div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({});
</script>
